(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8522],{

/***/ 42833:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jargon",
      function () {
        return __webpack_require__(84172);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ JargonHubFeature; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/landing/feature-jargon/src/index.ts + 8 modules
var src = __webpack_require__(88840);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 264 modules
var shared_src = __webpack_require__(60620);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 57 modules
var ui_src = __webpack_require__(72284);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var next_router = __webpack_require__(35837);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon-hub/src/lib/assets/Speech3D.svg
var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SvgSpeech3D = props => /*#__PURE__*/react.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 94 94"
}, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
  id: "a",
  x1: "53.054%",
  x2: "30.056%",
  y1: "35.032%",
  y2: "94.731%"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0%",
  stopOpacity: 0
}), /*#__PURE__*/react.createElement("stop", {
  offset: "100%"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "b",
  x1: "88.433%",
  x2: "19.657%",
  y1: "-20.567%",
  y2: "97.049%"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0%",
  stopColor: "#57E8FC"
}), /*#__PURE__*/react.createElement("stop", {
  offset: "100%",
  stopColor: "#FFFF8F"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "c",
  x1: "68.39%",
  x2: "32.496%",
  y1: "-7.654%",
  y2: "111.048%"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0%",
  stopColor: "#57E8FC"
}), /*#__PURE__*/react.createElement("stop", {
  offset: "100%",
  stopColor: "#FFFF8F"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "d",
  x1: "144.762%",
  x2: "9.012%",
  y1: "-49.815%",
  y2: "91.34%"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0%",
  stopColor: "#57E8FC"
}), /*#__PURE__*/react.createElement("stop", {
  offset: "100%",
  stopColor: "#FFFF8F"
})))), _g || (_g = /*#__PURE__*/react.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/react.createElement("path", {
  fill: "url(#a)",
  d: "M21.91 82.88c-1.633.947-3.207 1.669-4.699 2.186l-6.199 8.706a2.89 2.89 0 0 1-.869.823 1.485 1.485 0 0 1-.586.204.905.905 0 0 1-.263-.014c-.028-.006-.05-.02-.076-.03-.52-.17-.732-.87-.463-1.759l2.105-7.049c-1.965-.257-3.489-1.14-4.43-2.584-.667-1.022-1.051-2.313-1.056-3.9-.02-7.165 7.35-17.251 16.464-22.532 3.119-1.807 6.026-2.798 8.517-3.058 2.058-.214 3.835.064 5.181.847v.001c.268.156.513.338.747.532.07.058.132.119.198.18.166.152.32.315.466.488.058.069.117.137.172.209.183.243.354.498.499.777 0 .003.003.005.004.008.146.28.264.586.368.905.032.094.056.193.083.29.069.244.125.498.17.762.018.106.037.21.05.319.048.368.08.747.081 1.15.02 7.166-7.35 17.259-16.463 22.54m16.414-33.526a8.935 8.935 0 0 0-.548-.284c-.052-.024-.101-.052-.153-.076a8.99 8.99 0 0 0-.746-.293c-.068-.023-.138-.041-.208-.063a11.45 11.45 0 0 0-.587-.168c-.096-.023-.195-.043-.293-.064a10.186 10.186 0 0 0-1.454-.212c-.1-.007-.201-.017-.303-.023a13.502 13.502 0 0 0-.758-.019l-.162-.003c-.312.005-.63.021-.953.045-.092.008-.187.02-.281.03-.234.022-.47.047-.709.08-.12.017-.242.037-.365.056a20.433 20.433 0 0 0-1.758.365c-.116.03-.233.057-.35.089-.32.087-.643.18-.968.284l-.11.033c-.363.118-.73.247-1.1.384-.113.042-.227.089-.34.133-.262.102-.524.206-.789.317-.137.058-.275.12-.414.18a32.055 32.055 0 0 0-1.966.945c-.125.065-.249.127-.373.194-.39.21-.782.427-1.176.657C10.148 58.541.485 71.865.515 82.481c.001.529.03 1.037.08 1.526.016.164.049.314.071.473.044.315.086.633.15.93.038.18.094.344.14.516.07.259.135.52.22.763.06.174.136.333.205.498.091.222.18.447.286.655.082.16.177.308.268.46.113.19.224.386.35.564.103.146.217.277.328.413a7.628 7.628 0 0 0 2.401 1.977l-.777 2.614c-.108.362-.189.712-.258 1.058l-.048.251c-.06.34-.108.672-.132.991l-.001.033a8.326 8.326 0 0 0-.003 1.11c.018.29.049.57.1.833l.014.053c.05.247.119.478.197.7.02.056.04.113.064.169.09.226.192.44.312.633.012.02.026.034.038.053.113.174.242.332.38.477.036.038.072.076.11.112.156.149.322.282.505.39.541.323 1.195.47 1.948.4.749-.07 1.54-.351 2.326-.81 1.23-.719 2.451-1.87 3.484-3.326l4.694-6.64a35.036 35.036 0 0 0 3.596-1.837C32.88 81.916 42.544 68.6 42.515 57.977c-.012-4.259-1.584-7.131-4.19-8.622",
  opacity: 0.142,
  transform: "scale(-1 1) rotate(44 0 21.4)"
}), /*#__PURE__*/react.createElement("path", {
  fill: "url(#b)",
  d: "M53.458 18.294a8.713 8.713 0 0 0-.2-.903c-.032-.114-.062-.231-.098-.342a7.266 7.266 0 0 0-.436-1.072l-.005-.008a6.3 6.3 0 0 0-.59-.92c-.065-.086-.136-.166-.205-.248a6.233 6.233 0 0 0-.55-.577c-.078-.072-.153-.146-.235-.213a6.372 6.372 0 0 0-.883-.63h-.001c-1.592-.928-3.694-1.258-6.13-1.004.16.693.246 1.447.248 2.266.024 8.481-8.697 20.426-19.482 26.676-1.932 1.12-3.795 1.975-5.561 2.588L16.6 47.74l-.788-.46c1.114 1.708 2.918 2.755 5.243 3.058l-2.49 8.343c-.32 1.053-.068 1.881.546 2.083.032.01.058.028.09.034.096.02.2.028.311.018a1.75 1.75 0 0 0 .694-.243c.364-.21.725-.547 1.03-.974l7.334-10.303c1.767-.613 3.63-1.467 5.562-2.587 10.784-6.25 19.507-18.195 19.483-26.677a11.325 11.325 0 0 0-.096-1.362c-.016-.128-.04-.252-.06-.377",
  transform: "translate(33 10)"
}), /*#__PURE__*/react.createElement("path", {
  fill: "url(#c)",
  d: "M14.56 66.75c-.046-.043-.087-.088-.13-.132a3.977 3.977 0 0 1-.45-.562c-.014-.022-.03-.04-.045-.061a4.817 4.817 0 0 1-.369-.745c-.027-.066-.051-.133-.075-.2a6.141 6.141 0 0 1-.234-.82c-.005-.023-.011-.041-.015-.063a7.595 7.595 0 0 1-.132-1.234 9.723 9.723 0 0 1 .017-1.09c.028-.374.086-.766.157-1.164l.056-.295c.082-.407.178-.82.306-1.244l.92-3.073-.566-.33c.049.03.092.068.142.096l-8.82-5.145-.917 3.06c-1.141 3.817-.443 6.932 1.528 8.082l9.241 5.391-.016-.013a3.346 3.346 0 0 1-.598-.459",
  transform: "translate(33 10)"
}), /*#__PURE__*/react.createElement("path", {
  fill: "url(#d)",
  d: "M14.142 55.834c-.05-.029-.092-.067-.143-.097l.568.33a9.012 9.012 0 0 1-2.513-1.94l-.011.016c-.114-.126-.211-.27-.32-.4-.13-.16-.266-.316-.387-.486-.15-.21-.281-.438-.415-.664-.106-.179-.22-.351-.316-.54-.126-.244-.23-.509-.339-.77-.082-.195-.171-.381-.244-.585-.1-.286-.177-.593-.259-.897-.054-.204-.12-.395-.166-.607-.076-.349-.125-.722-.177-1.094-.026-.187-.065-.363-.085-.556a17.52 17.52 0 0 1-.094-1.794c-.036-12.48 11.4-28.142 24.787-35.9.466-.27.93-.526 1.392-.772.148-.079.295-.152.441-.228.316-.163.63-.322.943-.475.168-.08.335-.16.504-.238.295-.138.589-.27.881-.399.164-.071.327-.143.49-.21.312-.132.623-.254.933-.373.133-.052.269-.107.402-.156a29.3 29.3 0 0 1 1.302-.452c.044-.014.087-.025.13-.038.385-.122.767-.234 1.146-.335.14-.038.276-.07.414-.105.282-.07.562-.137.839-.198a23.837 23.837 0 0 1 1.242-.23c.144-.023.288-.047.432-.066.283-.04.561-.069.839-.095.11-.011.223-.025.333-.034.381-.03.758-.047 1.126-.053.066-.001.128.003.193.003.302 0 .603.006.897.022.121.007.239.018.358.028a13.87 13.87 0 0 1 1.072.126c.22.035.436.077.65.122.116.025.233.049.346.076.236.059.467.125.695.197.081.026.165.047.245.074.303.102.598.217.883.345.062.027.12.061.181.09.222.104.438.213.65.333.03.018.063.03.093.048l-9.241-5.39C40.242-1.215 32.861-.22 24.788 4.459 11.4 12.217-.035 27.88 0 40.36c.014 4.866 1.815 8.282 4.9 10.083l.422.246 8.82 5.145z",
  transform: "translate(33 10)"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#57E8FC",
  d: "M67.132 56.71c-1.933 1.12-3.796 1.975-5.561 2.587L54.235 69.6c-.305.426-.664.763-1.028.974-.234.136-.47.22-.694.242a1.07 1.07 0 0 1-.311-.017c-.033-.007-.06-.025-.09-.034-.615-.202-.866-1.03-.548-2.083l2.49-8.343c-2.324-.304-4.127-1.35-5.241-3.058-.79-1.21-1.244-2.739-1.25-4.616-.023-8.48 8.698-20.42 19.483-26.669 3.69-2.14 7.131-3.312 10.079-3.62 2.435-.253 4.537.077 6.13 1.004.317.185.608.4.884.63.082.068.157.14.235.213.196.18.378.373.55.577.07.082.14.162.205.248.217.287.419.589.59.92.001.003.004.005.005.009.172.332.312.694.436 1.071.037.111.066.228.098.342.08.29.147.59.2.903.022.125.045.248.061.377.056.436.094.884.095 1.363.024 8.48-8.697 20.426-19.482 26.676M86.986 16.81a10.6 10.6 0 0 0-.648-.334c-.063-.028-.12-.061-.182-.09a10.68 10.68 0 0 0-.883-.344c-.08-.026-.163-.048-.245-.074a12.173 12.173 0 0 0-.695-.197c-.114-.027-.23-.052-.347-.076a12.126 12.126 0 0 0-1.72-.249c-.12-.008-.239-.02-.36-.027a16.085 16.085 0 0 0-.897-.022c-.063 0-.127-.004-.191-.003-.37.005-.745.024-1.128.052-.109.01-.221.023-.333.034a19.57 19.57 0 0 0-.838.096c-.143.02-.287.043-.433.066a24.327 24.327 0 0 0-2.08.428c-.138.036-.275.067-.415.105-.378.102-.76.212-1.145.334l-.13.039c-.43.138-.864.29-1.303.451-.133.05-.267.105-.402.156-.309.12-.62.243-.933.373-.161.068-.325.14-.49.212a38.058 38.058 0 0 0-2.326 1.11c-.148.078-.294.15-.442.229a43.45 43.45 0 0 0-1.392.772c-13.387 7.758-24.822 23.42-24.787 35.9.002.623.035 1.22.094 1.795.02.193.059.369.085.556.052.37.101.744.177 1.094.046.21.111.403.167.606.08.304.158.611.259.897.072.204.162.39.242.585.109.26.215.525.34.77.096.188.209.362.316.54.134.225.266.455.415.664.121.171.257.326.388.486a9.02 9.02 0 0 0 2.842 2.324l-.92 3.073a13.55 13.55 0 0 0-.306 1.244l-.057.295c-.07.398-.128.79-.156 1.165l-.001.038a9.723 9.723 0 0 0-.015 1.05c.003.086.006.172.012.255.021.34.057.67.119.98.004.022.01.04.015.062.06.29.14.562.234.822a4.817 4.817 0 0 0 .445.944c.014.022.03.04.044.061.135.206.287.39.45.562.043.044.086.089.13.132.185.174.382.33.598.458.64.38 1.414.552 2.305.47.887-.083 1.822-.413 2.753-.953 1.456-.844 2.9-2.199 4.123-3.91l5.555-7.805a41.568 41.568 0 0 0 4.256-2.16c13.393-7.763 24.829-23.417 24.794-35.905-.014-5.007-1.874-8.384-4.958-10.136"
}))));
/* harmony default export */ var Speech3D = (SvgSpeech3D);
;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon-hub/src/lib/assets/index.ts


// EXTERNAL MODULE: ../../../node_modules/react-final-form/dist/react-final-form.es.js + 5 modules
var react_final_form_es = __webpack_require__(51080);
// EXTERNAL MODULE: ../../../libs/landing/feature-jargon-hub/src/lib/components/search-form/search-form.module.css
var search_form_module = __webpack_require__(92780);
var search_form_module_default = /*#__PURE__*/__webpack_require__.n(search_form_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon-hub/src/lib/components/search-form/text-field-search.tsx


const TextFieldWrapper = ({ errorDisplay ="realtime" , input , meta , onBlur , tooltip , label , inputRef , ...rest })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TextField */.nv, {
        ...rest,
        label: label,
        id: rest.id,
        name: input.name,
        type: input.type ? input.type : "text",
        value: input.value,
        onChange: input.onChange,
        onBlur: (e)=>{
            input.onBlur(e);
            if (onBlur) onBlur(e);
        },
        onFocus: input.onFocus,
        ref: inputRef
    });
/* harmony default export */ var text_field_search = (TextFieldWrapper);

;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon-hub/src/lib/components/search-form/search-form.tsx





const SearchForm = ({ onSubmit , initialValues ={} , isPending  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
        onSubmit: onSubmit,
        initialValues: initialValues,
        render: ({ handleSubmit , pristine  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                name: "jargon-search",
                onSubmit: handleSubmit,
                className: (search_form_module_default()).form,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                        id: "searchInput",
                        name: "search",
                        type: "search",
                        component: text_field_search,
                        label: "I want to understand",
                        autoComplete: "off",
                        placeholder: "E.g. Car Insurance",
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                        classNames: {
                            button: (search_form_module_default()).button
                        },
                        type: "submit",
                        disabled: pristine || isPending,
                        isLoading: isPending,
                        children: "Search"
                    })
                ]
            })
    });

// EXTERNAL MODULE: ../../../libs/landing/feature-jargon-hub/src/lib/feature-jargon-hub.module.css
var feature_jargon_hub_module = __webpack_require__(93844);
var feature_jargon_hub_module_default = /*#__PURE__*/__webpack_require__.n(feature_jargon_hub_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon-hub/src/lib/feature-jargon-hub.tsx










const search = (filteredResults, setResults)=>new Promise((resolve, reject)=>{
        setResults(filteredResults);
        return resolve(filteredResults);
    });
const JargonHubFeature = ({ stories  })=>{
    var ref, ref1;
    const router = (0,next_router.useRouter)();
    const query = (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.q) === null || ref1 === void 0 ? void 0 : ref1.toString();
    const [searchQuery, setSearchQuery] = (0,react.useState)(query || "");
    const [filteredStories, setFilteredStories] = (0,react.useState)([]);
    const [isSearchPending, setSearchPending] = (0,react.useState)(false);
    const searchJargon = (q)=>{
        setSearchQuery(q || "");
        if (!q) {
            return;
        }
        q = q.toLowerCase();
        setSearchPending(true);
        const filtered = stories.filter((item)=>{
            var ref, ref1, ref2, ref3;
            return ((ref = item.content) === null || ref === void 0 ? void 0 : ref.fullTerm.toLowerCase().includes(q)) || ((ref1 = item.content) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.keywords) === null || ref2 === void 0 ? void 0 : ref2.split(",").map((p)=>p.toLowerCase()).includes(q)) || ((ref3 = item.content) === null || ref3 === void 0 ? void 0 : ref3.question.toLowerCase().includes(q));
        });
        return new Promise((resolve)=>{
            search(filtered, setFilteredStories).then(()=>{
                setSearchPending(false);
                resolve();
            }).catch(()=>{
                setSearchPending(false);
                resolve();
            });
        });
    };
    (0,react.useEffect)(()=>{
        if (query) {
            searchJargon(query);
        }
    }, [
        query
    ]);
    const storiesContent = stories.map((story)=>story.content);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: (feature_jargon_hub_module_default()).page,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* JsonLdScript */.HT, {
                schema: (0,shared_src/* formatFaqPageSchema */.TM)(storiesContent),
                tagId: "JargonPage"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                fallbackTitle: "Jargon Buster - cinch",
                fallbackDescription: "Want to understand more about how your car works or any obscure industry terms? Our jargon buster is here to make them faff-free."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (feature_jargon_hub_module_default()).container,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (feature_jargon_hub_module_default()).title,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    element: "h1",
                                    type: index_esm/* TextStyles.mainTitle */.k7.mainTitle,
                                    lineHeight: "display",
                                    children: "Jargon Buster"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm, {
                                initialValues: {
                                    search: searchQuery
                                },
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                onSubmit: (values)=>searchJargon(values.search),
                                isPending: isSearchPending
                            }),
                            !isSearchPending && filteredStories.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (feature_jargon_hub_module_default()).title,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                            element: "h2",
                                            type: index_esm/* TextStyles.vehicleSubTitle */.k7.vehicleSubTitle,
                                            lineHeight: "display",
                                            children: "Search Results"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "data-testid": "SearchResults",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* RelatedJargon */.zQ, {
                                            items: filteredStories
                                        })
                                    })
                                ]
                            }),
                            !isSearchPending && filteredStories.length === 0 && searchQuery && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (feature_jargon_hub_module_default()).noResultsWrapper,
                                "data-testid": "no-jargon-found",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        className: (feature_jargon_hub_module_default()).noResultsTitle,
                                        element: "h2",
                                        children: "Sorry, we haven't found any articles that match, try a different word or phrase"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* SVG */.Wj, {
                                        children: Speech3D,
                                        size: 195,
                                        className: (feature_jargon_hub_module_default()).noResultsImage
                                    })
                                ]
                            })
                        ]
                    }),
                    (stories === null || stories === void 0 ? void 0 : stories.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (feature_jargon_hub_module_default()).title,
                                "data-testid": "latest-jargon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    element: "h2",
                                    type: index_esm/* TextStyles.vehicleSubTitle */.k7.vehicleSubTitle,
                                    lineHeight: "display",
                                    children: "Latest"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* RelatedJargon */.zQ, {
                                items: stories
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var storyblok_src = __webpack_require__(60782);
;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon-hub/src/lib/get-static-props.ts

const getStaticProps = async ({ preview =false  })=>{
    try {
        const { stories  } = await getAllStories({
            starts_with: "jargon",
            version: preview ? "draft" : "published"
        });
        const customStories = stories.map((story)=>({
                content: {
                    question: story.content.question,
                    summary: story.content.summary,
                    fullTerm: story.content.fullTerm,
                    keywords: story.content.keywords
                },
                slug: story.slug
            }));
        return {
            props: {
                stories: customStories,
                preview,
                layoutProps: {
                    showBorderRadius: true
                }
            },
            revalidate: 60
        };
    } catch  {
        return {
            notFound: true,
            props: {
                stories: [],
                preview,
                layoutProps: {
                    showBorderRadius: true
                }
            },
            revalidate: 60
        };
    }
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon-hub/src/index.ts



;// CONCATENATED MODULE: ./pages/jargon/index.tsx
var __N_SSG = true;



/***/ }),

/***/ 88840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lp": function() { return /* reexport */ JargonFeature; },
  "zQ": function() { return /* reexport */ RelatedJargon; }
});

// UNUSED EXPORTS: getStaticPathsGenerator, getStaticPropsGenerator, jargonStaticPaths

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 57 modules
var src = __webpack_require__(72284);
// EXTERNAL MODULE: ../../../node_modules/next/link.js
var next_link = __webpack_require__(89218);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 264 modules
var shared_src = __webpack_require__(60620);
// EXTERNAL MODULE: ../../../libs/landing/feature-jargon/src/lib/components/keyword-list/keyword-list.module.css
var keyword_list_module = __webpack_require__(55257);
var keyword_list_module_default = /*#__PURE__*/__webpack_require__.n(keyword_list_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/lib/components/keyword-list/keyword-list.tsx




const KeywordList = ({ items  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (keyword_list_module_default()).keywords,
        "data-testid": "jargon-keywords",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                className: (keyword_list_module_default()).header,
                children: "Keywords"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (keyword_list_module_default()).list,
                children: items && items.map((keyword, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (keyword_list_module_default()).item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: `/jargon?q=${keyword}`,
                            passHref: true,
                            legacyBehavior: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TextLink */.hh, {
                                className: (keyword_list_module_default()).link,
                                children: keyword
                            })
                        })
                    }, index))
            })
        ]
    });

// EXTERNAL MODULE: ../../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(19601);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ../../../libs/landing/feature-jargon/src/lib/components/jargon-content/jargon-content.module.css
var jargon_content_module = __webpack_require__(90197);
var jargon_content_module_default = /*#__PURE__*/__webpack_require__.n(jargon_content_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/lib/components/jargon-content/jargon-content.tsx





const JargonContent = ({ question , answer , image  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: (jargon_content_module_default()).article,
        "data-testid": "jargon-article",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (jargon_content_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (jargon_content_module_default()).question,
                        children: question
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* RichTextStyles */.Px, {
                        children: [
                            (0,shared_src/* renderWithResolver */.be)(answer),
                            " "
                        ]
                    })
                ]
            }),
            image && image.filename && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (jargon_content_module_default()).imageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image.filename,
                    className: (jargon_content_module_default()).jargonImage,
                    layout: "responsive",
                    width: 592,
                    height: 310,
                    objectFit: "contain"
                })
            })
        ]
    });

// EXTERNAL MODULE: ../../../libs/landing/feature-jargon/src/lib/components/related-jargon/related-jargon.module.css
var related_jargon_module = __webpack_require__(16970);
var related_jargon_module_default = /*#__PURE__*/__webpack_require__.n(related_jargon_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/lib/components/related-jargon/related-jargon.tsx





const RelatedJargon = ({ items  })=>{
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: (related_jargon_module_default()).related,
        "data-testid": "jargon-list",
        children: items.length > 0 && items.filter((item)=>item && item.content).map((item, index)=>{
            var ref, ref1;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(shared_src/* Panel */.s_, {
                title: (ref = item.content) === null || ref === void 0 ? void 0 : ref.question,
                subtitle: (ref1 = item.content) === null || ref1 === void 0 ? void 0 : ref1.summary,
                isPadded: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (related_jargon_module_default()).link,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: `/jargon/${item.slug}`,
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Secondary */.T7, {
                            element: "a",
                            "data-testid": "jargonLink",
                            className: (related_jargon_module_default()).button,
                            children: "Read more"
                        })
                    })
                })
            }, index);
        })
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/lib/components/index.ts




// EXTERNAL MODULE: ../../../libs/landing/feature-jargon/src/lib/jargon.module.css
var jargon_module = __webpack_require__(68740);
var jargon_module_default = /*#__PURE__*/__webpack_require__.n(jargon_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/lib/utils/is-jargon-hub-story-content.ts
const isJargonHubStoryContent = (input)=>{
    const isJargonPage = Object.prototype.hasOwnProperty.call(input, "component") && input.component === "JargonPage";
    if (!isJargonPage) {
        console.error(`Expected to find JargonPage component, instead received: \n ${JSON.stringify(input, null, 2)}`);
    }
    return isJargonPage;
};

// EXTERNAL MODULE: ../../../node_modules/@mui/material/Skeleton/Skeleton.js + 12 modules
var Skeleton = __webpack_require__(78840);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var storyblok_src = __webpack_require__(60782);
;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/lib/jargon.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable react/jsx-no-target-blank */ 










const siteUrl = "https://www.cinch.co.uk/";
const JargonFeature = ({ story , preview =false  })=>{
    var ref;
    const prefersReducedMotion = (0,src/* usePrefersReducedMotion */.Tb)();
    const { content , slug  } = (0,storyblok_src/* useStoryblokState */.f0)({
        story: story,
        enableBridge: preview
    });
    const SEO = content === null || content === void 0 ? void 0 : (ref = content.SEO) === null || ref === void 0 ? void 0 : ref[0];
    if (!content || !isJargonHubStoryContent(content) || !story) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
            className: (jargon_module_default()).page,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* Wrapper */.im, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        sx: {
                            marginTop: "24px",
                            marginBottom: "16px"
                        },
                        animation: prefersReducedMotion ? false : "wave",
                        variant: "rectangular",
                        width: 500,
                        height: 56
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        sx: {
                            marginBottom: "56px"
                        },
                        animation: prefersReducedMotion ? false : "wave",
                        variant: "rectangular",
                        width: 300,
                        height: 30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        animation: prefersReducedMotion ? false : "wave",
                        variant: "rectangular",
                        className: (jargon_module_default()).skeleton
                    })
                ]
            })
        });
    } else {
        var ref1;
        const { fullTerm , term , question , answer , image , keywords , summary  } = content;
        const reducedRelatedJargon = (ref1 = story.rels) === null || ref1 === void 0 ? void 0 : ref1.map((relatedStory)=>{
            var ref, ref1, ref2, ref3;
            return {
                slug: relatedStory.slug ?? "",
                content: {
                    summary: ((ref = relatedStory.content) === null || ref === void 0 ? void 0 : ref.summary) ?? "",
                    question: ((ref1 = relatedStory.content) === null || ref1 === void 0 ? void 0 : ref1.question) ?? "",
                    keywords: ((ref2 = relatedStory.content) === null || ref2 === void 0 ? void 0 : ref2.keywords) ?? "",
                    fullTerm: ((ref3 = relatedStory.content) === null || ref3 === void 0 ? void 0 : ref3.fullTerm) ?? ""
                }
            };
        });
        const keywordList = keywords === null || keywords === void 0 ? void 0 : keywords.split(",").map((p)=>p.trim());
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                    ...SEO,
                    fallbackTitle: `${fullTerm} - cinch`,
                    fallbackDescription: summary
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                    className: (jargon_module_default()).page,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* Wrapper */.im, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (jargon_module_default()).header,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/jargon",
                                        passHref: true,
                                        legacyBehavior: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: (jargon_module_default()).headerLink,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                                                    name: "chevron-left",
                                                    height: 12,
                                                    color: "toreaBay"
                                                }),
                                                "All Jargon"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: `mailto:?subject=${question} - Cinch&body=${siteUrl}/jargon/${slug}`,
                                        passHref: true,
                                        legacyBehavior: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            target: "_blank",
                                            className: (jargon_module_default()).headerLink,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                                                    name: "share",
                                                    height: 16,
                                                    gradient: "newGalaxy"
                                                }),
                                                "Share by Email"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: (jargon_module_default()).fullTerm,
                                children: [
                                    fullTerm,
                                    term && ` (${term})`
                                ]
                            }),
                            keywordList && keywordList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordList, {
                                items: keywordList
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(JargonContent, {
                                question: question,
                                answer: answer,
                                image: image
                            }),
                            story.rels && story.rels.length > 0 && reducedRelatedJargon && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (jargon_module_default()).title,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                            element: "h2",
                                            type: index_esm/* TextStyles.mainTitle */.k7.mainTitle,
                                            lineHeight: "display",
                                            children: "Related Jargon"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedJargon, {
                                        items: reducedRelatedJargon
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/lib/get-static-props.ts

const getStaticPropsGenerator = ({ path  })=>{
    return async ({ params , preview =false  })=>{
        try {
            const slug = params === null || params === void 0 ? void 0 : params.slug;
            const story = await getStoryBySlug(`${path}/${slug}`, {
                version: preview ? "draft" : "published",
                cv: Date.now(),
                resolve_relations: "JargonPage.relatedJargon"
            });
            if (!story) {
                throw new Error("No story within jargon");
            }
            return {
                props: {
                    story,
                    preview,
                    layoutProps: {
                        showBorderRadius: true
                    }
                },
                revalidate: 60
            };
        } catch (error) {
            console.log(error);
            return {
                notFound: true,
                props: {
                    story: null,
                    preview,
                    layoutProps: {
                        showBorderRadius: true
                    }
                },
                revalidate: 60
            };
        }
    };
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/lib/get-static-paths.ts


const getStaticPathsGenerator = (slug)=>async ()=>{
        // Get the paths we want to pre-render based on data
        try {
            const links = await getLinks(slug);
            const paths = jargonStaticPaths({
                links
            });
            return {
                paths,
                fallback: "blocking"
            };
        } catch  {
            return {
                paths: [],
                fallback: "blocking"
            };
        }
    };

;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/index.ts







/***/ }),

/***/ 92780:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"search-form_form__nsuEb","button":"search-form_button__hDzr_"};

/***/ }),

/***/ 93844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"feature-jargon-hub_page__5XPiS","title":"feature-jargon-hub_title__Vwt8e","noResultsWrapper":"feature-jargon-hub_noResultsWrapper__hDhO_","noResultsTitle":"feature-jargon-hub_noResultsTitle__rSKCl","noResultsImage":"feature-jargon-hub_noResultsImage__W1Baf"};

/***/ }),

/***/ 90197:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"jargon-content_content__8Wl09","question":"jargon-content_question__c69Rl","article":"jargon-content_article__z7C_Y","imageWrapper":"jargon-content_imageWrapper__1YD_H","answer":"jargon-content_answer__KiTPu","jargonImage":"jargon-content_jargonImage__EJFoL"};

/***/ }),

/***/ 55257:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"keywords":"keyword-list_keywords__wVyht","header":"keyword-list_header__cfxLY","item":"keyword-list_item__UwcAk","list":"keyword-list_list__ZBBLG","link":"keyword-list_link__7OPku"};

/***/ }),

/***/ 16970:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"related":"related-jargon_related__gr6qU","link":"related-jargon_link__rtrun","button":"related-jargon_button__i0Grp"};

/***/ }),

/***/ 68740:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"jargon_header__eXOCz","headerLink":"jargon_headerLink__KFplA","icon":"jargon_icon__OnRTn","page":"jargon_page__zCTys","fullTerm":"jargon_fullTerm__sPRkb","title":"jargon_title__xpSmU","skeleton":"jargon_skeleton__3BB4V"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1080,9774,2888,179], function() { return __webpack_exec__(42833); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);